import { css } from 'styled-components';
export const productive_heading_01 = css`
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: var(--font-weight-bold);
`;
export const body_short_01 = css`
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 400;
`;
export const body_short_02 = css`
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
`;
